import Flatpickr from "stimulus-flatpickr"
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'

export default class extends Flatpickr {
  static values = {
    monthOnly:  { type: Boolean, default: false },
    allowInput: { type: Boolean, default: false },
    altFormat:  { type: String, default: 'M d, Y' },
    inline:     { type: Boolean, default: false }
  }

  connect() {
    this.config = {
      altInput: true,
      altFormat: this.altFormatValue,
      dateFormat: "Y-m-d",
      inline: this.inlineValue
    }

    if(this.monthOnlyValue) {
      this.config['plugins'] = [this.monthPlugin]
    }

    if (this.hasAllowInputValue) {
      this.config['allowInput'] = this.allowInputValue
    }

    super.connect()
  }

  // AppSignal #4957: stimulus-flatpickr's disconnect reads inputTarget.value.
  // That property is a copy of fp.input from connect, and it is missing when
  // Stimulus removes the input. Keep the date, then destroy the picker.
  disconnect() {
    const input = this.pickerInput()
    const value = input ? input.value : undefined

    this.destroyPicker(input)

    if (input && value !== undefined) input.value = value
  }

  clear(evt) {
    evt.preventDefault()
    this.fp.clear()
  }

  get monthPlugin() {
    return new monthSelectPlugin({ theme: "light", dateFormat: "Y-m-d" })
  }

  pickerInput() {
    if (this.hasInputValue(this.inputTarget)) return this.inputTarget
    if (this.fp && this.hasInputValue(this.fp.input)) return this.fp.input
    if (this.hasInputValue(this.element)) return this.element

    return null
  }

  destroyPicker(input) {
    const picker = this.fp
    if (!picker || typeof picker.destroy !== "function") return

    // destroy() with altInput writes input.type and throws if input is null.
    if (!picker.input && input) picker.input = input

    if (picker.input) {
      picker.destroy()
      return
    }

    try {
      picker.destroy()
    } catch (_error) {
      // The original input is already gone, so altInput cleanup cannot finish.
    }
  }

  hasInputValue(input) {
    return !!input && typeof input.value === "string"
  }
}
